import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getDocUrl = createAsyncThunk("Docs/getDocUrl", async (params, thunkAPI) => {
    const {handleSuccess,folder_id}=params;
  try {
     
    const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}api/docs/folders/${folder_id}/pdfs`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
      if (handleSuccess) {
        handleSuccess(resp.data?.data);
      }
    return resp.data?.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
